/*@flow*/
import useContextState from './useContextState';

export default function useInit<T>(keyPath: string[], notSetVal: T): T {
  const s = useContextState();
  const kp = ['initCompState'].concat(keyPath);
  return (s: any).getIn(kp, notSetVal);
}
